module.exports = __webpack_public_path__ + "img/serves.a4e5dbba.png";